import React, { useContext } from 'react'
import { useEffect } from 'react';
import { sendCommand } from '../../../util/util';
import AppContext from '../../Context/AppContext';
import { SimpleText } from '../style';

const Timer = ({initialSeconds,seconds,setSeconds}) => {
    const {turn, isGameStarter, websocket} = useContext(AppContext);

    useEffect(()=>{
        if(seconds === 0 && isGameStarter && turn !== "vote") {
            sendCommand(websocket, "next_turn");
            setSeconds(initialSeconds);
        }

        if(seconds === 0 && turn === "vote") {
            sendCommand(websocket, "kill_vote");
        }

        let myInterval = setInterval(() => {
            if (seconds > 0) {
                setSeconds(seconds - 1);
            }
            if (seconds === 0) {
                setSeconds(initialSeconds);
            } 
            if (seconds === 10) {
                const message = seconds + " seconds left until next turn." 
                sendCommand(websocket, "msg", message);
            }
        }, 1000);

        return ()=> {
            clearInterval(myInterval);
        };

        // eslint-disable-next-line
    }, [seconds, turn]);

    return (
        <>
        { seconds === 0
            ? null
            : <SimpleText>{seconds < 10 ?  `0${seconds}` : seconds}</SimpleText>
        }
        </>
    )
}

export default Timer;